module.exports = __webpack_public_path__ + "static/media/ups1.8dd2f950.png";